import { CountriesInterface } from '../../../interfaces/dto/countries/countries-interface';
import { DistrictsModel } from '../districts/districts-model';

export class CountriesModel implements CountriesInterface {
  id: number = -1;
  name: string = '';
  designation: string = '';
  isoCode2: string = '';
  isoCode3: string = '';
  phonePrefix: string = '';
  flag: string = '';
  districts: DistrictsModel[] = new Array<DistrictsModel>();

  constructor(init?: Partial<CountriesModel>) {
    Object.assign(this, init);
  }
}
